import { isScalar } from './validate';

export const deepCompare = (obj1, obj2) => {
  if (typeof obj1 !== typeof obj2) return false;

  if (isScalar(obj1) || isScalar(obj2)) {
    return obj1 === obj2;
  }

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    return arrayCompare(obj1, obj2);
  }

  if (typeof obj1 === 'object' && typeof obj2 === 'object') {
    if (!arrayCompare(Object.keys(obj1), Object.keys(obj2))) return false;

    for (const key in obj1) {
      if (!deepCompare(obj1[key], obj2[key])) return false;
    }

    return true;
  }
};

export const arrayCompare = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;

  const ca = [...arr1];
  const cb = [...arr2];

  for (const a of ca) {
    const index = cb.findIndex((b) => deepCompare(a, b));
    if (index === -1) return false;
    cb.splice(index, 1);
  }

  return cb.length === 0;
};
